module.exports = __webpack_public_path__ + "src/assets/games/11/300.jpg";